module.exports = __webpack_public_path__ + "60f0111c50a58356d5b94069ab68a983.svg";